<template>
  <div class="widget__cut-time" :class="classes" v-if="hasCompany && cutTime">
    <small style="text-transform: uppercase" v-if="cutTime.type === 'week'" v-translate>Cut hour for Mon to Fri</small>
    <small style="text-transform: uppercase" v-if="cutTime.type === 'saturday'" v-translate>Cut hour for Saturday</small>
    <small style="text-transform: uppercase" v-if="cutTime.type === 'sunday'" v-translate>Cut hour for Sunday</small>
    <h3 class="m-0" style="line-height: 1" v-if="cutTime.time">
      {{cutTime.time.split(':')[0] + ':00'}}
      <small><font-awesome-icon icon="question-circle" :class="classes ? classes : 'text-info'" size="1x" :id="'tooltip-cuthour-' + rnd" /></small>
      <b-tooltip :target="'tooltip-cuthour-' + rnd">
        <span v-translate="{helpEmail: this.helpEmail}">This is the daily time limit to same-day shippings. If you need to change it, please, contact us at <a href="mailto:%{helpEmail}">%{helpEmail}</a>.</span>
      </b-tooltip>
    </h3>
    <div v-else>
      <h3 class="m-0" style="line-height: 1"><translate>N/A</translate>
        <small><font-awesome-icon icon="question-circle" :class="classes ? classes : 'text-info'" size="1x" :id="'tooltip-no-cuthour-' + rnd" /></small>
      </h3>
      <b-tooltip :target="'tooltip-no-cuthour-' + rnd">
        <span v-translate="{helpEmail: this.helpEmail}">It looks like you don't work today. If you need to change it, please, contact us at <a href="mailto:%{helpEmail}">%{helpEmail}</a>.</span>
      </b-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WidgetCutTime',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rnd: Math.random()
    }
  }
}
</script>
